import { memo } from 'react'
import type { ContratoItem } from '@hooks/useContratos.js'
import { Badge } from '@components/primitives/Badge.js'
import { formatCurrency, formatDate } from '@utils/format.js'
import { STATUS_LABEL, STATUS_VARIANT, TIPO_LABEL } from './contratosLabels.js'
import { PagamentoBar } from './PagamentoBar.js'

interface Props {
  item: ContratoItem
  onOpen: (id: number) => void
}

export const ContratoCard = memo(function ContratoCard({ item, onOpen }: Props) {
  const { resumo } = item
  const proxima = resumo.proximaParcela
  const hoje = new Date().toISOString().slice(0, 10)
  const proximaVencida = Boolean(proxima?.dataPrevista && proxima.dataPrevista < hoje)

  return (
    <button
      type='button'
      className={`cf3-contrato${item.status !== 'ativo' ? ` cf3-contrato--${item.status}` : ''}`}
      onClick={() => onOpen(item.id)}
    >
      <div className='cf3-contrato__head'>
        <div className='cf3-contrato__info'>
          <h3 className='cf3-contrato__titulo'>{item.titulo}</h3>
          <p className='cf3-contrato__prestador'>
            {item.prestador}
            <span aria-hidden> · </span>
            <span className='cf3-contrato__tipo'>{TIPO_LABEL[item.tipo]}</span>
          </p>
        </div>
        <Badge label={STATUS_LABEL[item.status]} variant={STATUS_VARIANT[item.status]} size='sm' />
      </div>

      <PagamentoBar pctPago={resumo.pctPago} pctLiberado={resumo.pctLiberado} compact />

      <div className='cf3-contrato__nums'>
        <span>
          <strong>{formatCurrency(resumo.pago)}</strong> pago
        </span>
        <span>de {formatCurrency(item.valorTotal)}</span>
      </div>

      {item.status === 'ativo' && (
        <p
          className={`cf3-contrato__proxima${proximaVencida ? ' cf3-contrato__proxima--vencida' : ''}`}
        >
          {proxima
            ? `${proximaVencida ? 'Vencida' : 'Próxima'}: ${proxima.descricao} · ${formatCurrency(proxima.valor)}${proxima.dataPrevista ? ` · ${formatDate(proxima.dataPrevista)}` : ''}`
            : 'Sem parcelas pendentes'}
        </p>
      )}

      {resumo.adiantamentoPct > 0 && item.status === 'ativo' && (
        <p className='cf3-contrato__aviso'>Pago {resumo.adiantamentoPct}% além do medido</p>
      )}
    </button>
  )
})
